export default __webpack_public_path__ + "static/benebay-logo-03bb220c2676e699b9d8f6a8b33a9505.png";